<template>
  <div>
    <div id="wrapper">
      <img src="../assets/my/2025.png" style="height:120px;"/>
    		<div id="content" style="height:690px;">
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Venue
    				</strong>
    			</p>
    			<p>
    				The IEEE BIBM 2025 is organized as an in-person conference in Wuhan,China

    				<a href=" https://biod.whu.edu.cn/bibm2025/">venue to be announced</a>(the hotel booking cutoff date will be announced)

    			</p>
    		</div>
    	</div>
      <footer-component></footer-component>
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
</style>
